export default [
    // {
    //     href: '/admin/dashboard',
    //     title: 'Dashboard',
    //     icon: 'icon-dice-five'
    // },

    {
        header: true,
        title: 'Quản lý quan hệ khách hàng'
    },
    {
        title: 'Quản lý người dùng',
        icon: 'icon-user-cog',
        child: [
            {
                href: '/user',
                title: 'Danh sách người dùng',
                permission : 'user-view'
            },
            {
                href: '/user-group',
                title: 'Nhóm người dùng',
                permission : 'userGroup-view'
            }

        ],
        permission : ["user-view", "userGroup-view"]
    },
    {
        title: 'Theo dõi Appoint',
        icon: 'icon-users',
        child: [
            {
                href: '/appoint',
                title: 'Danh sách Appoint',
                permission : 'appoint-view'
            },
        ],
        permission : 'appoint-view'
    },
    // {
    //     title: 'Nhân viên',
    //     icon: 'icon-users-class',
    //     child: [
    //         {
    //             href: '/employee/',
    //             title: 'Danh sách nhân viên',
    //             permission : 'employee-view'
    //         },
    //
    //     ],
    //     permission : 'employee-view'
    // },
    {
        title: 'Khách hàng',
        icon: 'icon-user',
        child: [
            {
                href: '/customer',
                title: 'Danh sách khách hàng',
                permission : 'customer-view'
            },
            {
                href: '/customer-visit-history',
                title: 'Lịch sử sang thăm công ty',
                permission : 'customerVisitHistory-view'
            },

        ],
        permission : ["customerVisitHistory-view", "customer-view"]
    },
    {
        title: 'Presales',
        icon: 'icon-share',
        child: [
            {
                href: '/pre-sale',
                title: 'Danh sách Presales',
                permission : 'preSales-view'
            },
        ],
        permission : 'preSales-view'
    },

    // {
    //     title: 'Cài đặt',
    //     icon: 'icon-cog',
    //     href: '/master-data',
    //     permission : 'master-data-view'
    // },
]
